var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.607,
    height: 16.084,
    viewBox: "0 0 16.607 16.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M.921,8.644l2.465,1.8-.936,2.9A2.235,2.235,0,0,0,5.9,15.831l2.41-1.774,2.411,1.772a2.234,2.234,0,0,0,3.45-2.486l-.936-2.9,2.465-1.8a2.234,2.234,0,0,0-1.315-4.038H11.357l-.919-2.864a2.234,2.234,0,0,0-4.255,0L5.264,4.606H2.24A2.234,2.234,0,0,0,.924,8.644Z",
    transform: "translate(-0.008 -0.19)",
    fill: "#fdd448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8fcef9b8586ee46471f4c3b734845fb9.svg";
export { ForwardRef as ReactComponent };